module.exports = __webpack_public_path__ + "img/options-color.626da1dd.svg";